









import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import request from '@/util/request';

@Component({inheritAttrs: false})
export default class MaterialUnitSelect extends Vue {
    @Prop({default: ''}) value!: string;
    @Prop({default: 'fabric'}) stuffType!: string;
    @Prop({default: true}) preserveValue!: boolean;
    units: {fabric: string[]; accessory: string[]} = {fabric: [], accessory: []};
    loading = true;
    failed = false;

    get options() {
        return this.stuffType === 'fabric' ? this.units.fabric : this.units.accessory;
    }

    @Watch('stuffType')
    normalizeValue() {
        if (!this.loading && !this.failed && !this.preserveValue && this.options.indexOf(this.value) === -1) {
            this.$emit('input', this.options[0] || '');
        }
    }

    created() {
        this.fetchUnits();
    }

    onVisibleChange(visible: boolean) {
        if (visible) this.fetchUnits();
    }

    async fetchUnits() {
        this.loading = true;
        try {
            const res = await request.get('/api/trade_base/material-units');
            if (!res || !res.status) throw new Error('单位配置加载失败');
            this.units = res.data;
            this.failed = false;
        } catch (error) {
            this.failed = true;
            this.$message.error(error.message || '单位配置加载失败，请刷新页面重试');
        } finally {
            this.loading = false;
            this.normalizeValue();
        }
    }
}
